import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getLanguages = createAsyncThunk(
    "languages/getLanguages",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_URL}/languages`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Language delete
export const deleteLanguage = createAsyncThunk(
    "languages/deleteLanguage",
    async (id, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`${API_URL}/languages/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return id;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Language could not be deleted"
            );
        }
    }
);

// Language update
export const updateLanguage = createAsyncThunk(
    "languages/updateLanguage",
    async ({ id, name }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.put(`${API_URL}/languages/${id}`, { name }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Language could not be updated"
            );
        }
    }
);

// Language create
export const createLanguage = createAsyncThunk(
    "languages/createLanguage",
    async (languageData, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(`${API_URL}/languages`, languageData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Language could not be created"
            );
        }
    }
);

const languageSlice = createSlice({
    name: "languages",
    initialState: {
        languages: [],
        loading: false,
        error: null,
    },
    reducers: {
        setFetchedLanguages: (state, action) => {
            state.fetchedLanguages = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLanguages.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getLanguages.fulfilled, (state, action) => {
                state.fetchedLanguages = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getLanguages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Create language
            .addCase(createLanguage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createLanguage.fulfilled, (state, action) => {
                state.loading = false;
                state.fetchedLanguages.push(action.payload);
            })
            .addCase(createLanguage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Update language
            .addCase(updateLanguage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateLanguage.fulfilled, (state, action) => {
                state.loading = false;
                state.fetchedLanguages = state.fetchedLanguages.map(lang =>
                    lang._id === action.payload._id ? action.payload : lang
                );
            })
            .addCase(updateLanguage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete language
            .addCase(deleteLanguage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteLanguage.fulfilled, (state, action) => {
                state.loading = false;
                state.fetchedLanguages = state.fetchedLanguages.filter(lang => lang._id !== action.payload);
            })
            .addCase(deleteLanguage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});
export const { setFetchedLanguages } =
  languageSlice.actions;

export default languageSlice.reducer;